import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { Exclusion } from '../models/exclusion.model';

@Injectable({
  providedIn: 'root',
})
export class ExclusionDal {
  constructor(private httpClient: HttpClient) {}

  getAllExclusions(): Observable<any[]> {
    return this.httpClient.get<any[]>(urlEndPoints.exclusions);
  }

  getExclusions(profileId: string, isIndividualJobDescription: boolean, hospital: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${urlEndPoints.exclusions}${profileId}?isIndividualJobDescription=${isIndividualJobDescription}&hospital=${hospital}`
    );
  }

  modifyExclusions(exclusions: Exclusion[]): Observable<any[]> {
    return this.httpClient.put<any[]>(urlEndPoints.exclusions + 'updateMany', exclusions);
  }

  deleteExclusions(exclusionId: string) {
    return this.httpClient.delete<any>(urlEndPoints.exclusions + exclusionId);
  }

  deleteManyExclusions(exclusionIds: string[]) {
    return this.httpClient.post<any>(urlEndPoints.exclusions + 'deleteMany', { exclusionIds });
  }

  addExclusions(exclusions: any[]) {
    return this.httpClient.post<any>(urlEndPoints.exclusions, exclusions);
  }
}
